import React from "react"
import { Link, StaticQuery, graphql } from "gatsby"

class Header extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      navOpen: false,
    }
  }

  _toggleNav = () => {
    this.setState(
      state => ({navOpen: !state.navOpen}),
      () => {
        if (this.state.navOpen) {
          document.body.classList.add('has-no-scroll');
        } else {
          document.body.classList.remove('has-no-scroll');
        }
    })
  }

  _navigate = () => {
    document.body.classList.remove('has-no-scroll');
  }

  render() {
    return (
      <StaticQuery
        query={headerQuery}
        render={data => {
          const header = data.allMarkdownRemark.edges.filter(item => item.node.fileAbsolutePath.indexOf('header') >= 0)[0];
          const blogs = data.allMarkdownRemark.edges.filter(item => item.node.fileAbsolutePath.indexOf('blog') >= 0 && item.node.fileAbsolutePath.indexOf('template') === -1);
          const caseStudies = data.allMarkdownRemark.edges.filter(item => item.node.fileAbsolutePath.indexOf('case-study') >= 0 && item.node.fileAbsolutePath.indexOf('template') === -1);

          const hasCaseStudies = caseStudies.length
          const hasBlogs = blogs.length > 0
          return (
            <header>
                <button
                    className={`hamburger hamburger--boring ${this.state.navOpen ? 'is-open' : 'is-closed'} `}
                    type="button"
                    aria-label="Toggle navigation"
                    data-offscreen-id="nav"
                    onClick={this._toggleNav}s
                >
                    <span className="hamburger-box">
                      <span className="hamburger-inner">
                        <span className="vh">Toggle navigation</span>
                      </span>
                    </span>
                </button>

                <div className="home-link-container">
                    <Link className="home-link" to="/">
                        {header.node.frontmatter.name}, {header.node.frontmatter.role}
                        <span className="vh">homepage</span>
                    </Link>
                </div>

                <div className={`nav-menu ${this.state.navOpen ? 'is-open' : 'is-closed'}`}>
                  <nav>
                    {hasCaseStudies && (
                      <>
                        {hasCaseStudies && hasBlogs && (
                          <div className="nav-section-title">Case Studies</div>
                        )}
                        <ul>
                          {caseStudies.map(caseStudy => {
                            return (
                              <li key={caseStudy.node.fields.slug}>
                                <Link className="nav-link" to={`case-study${caseStudy.node.fields.slug}`} onClick={this._navigate}>{caseStudy.node.frontmatter.title}</Link>
                              </li>
                            )
                          })}
                        </ul>
                      </>
                    )}
                    {hasBlogs && (
                      <>
                        {hasCaseStudies && hasBlogs && (
                          <div className="nav-section-title">Blog Post</div>
                        )}
                        <ul>
                          {blogs.map(blog => {
                            return (
                              <li key={blog.node.fields.slug}>
                                <Link className="nav-link" to={`blog${blog.node.fields.slug}`} onClick={this._navigate}>{blog.node.frontmatter.title}</Link>
                              </li>
                            )
                          })}
                        </ul>
                      </>
                    )}
                  </nav>
                </div>
            </header>
          )
        }}
      />
    )
  }
}

export default Header;

const headerQuery = graphql`
  query HeaderQuery {
    allMarkdownRemark {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
            date
            name
            role
          }
          fileAbsolutePath
          html
        }
      }
    }
  }
`